import React from "react";
import GracePaperBanner from "./Banner";
import WelcomePaper from "./WelcomePaper";
import "./GracePaper.css";
import OurPaperProduct from "./OurPaperProduct";
import ImageGallery from "./ImageGallery";
import PaperAboutUs from "./AboutUs";
import GetInTouch from "../GraceHome/GetInTouch";
import GraceFooter from "../GraceHome/Footer";
import PaperHeader from "./Header";
// import TestiMonials from "./TestiMonials";
import { FaWhatsapp } from "react-icons/fa";
import PaperGetInTouch from "./GetInTouch";

const GracePaper = () => {
    const whatsappNumber = "9655214330";
    const preOccupiedMessage = "Hello GraceAssociates!\n I would like to know more about your services.";
    // const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(preOccupiedMessage)}`;
    const whatsappLink = `https://wa.me/c/919585833484`;
    return (
        <>
            <PaperHeader />
            <GracePaperBanner />
            <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp-chat-icon"
            >
                <FaWhatsapp />
            </a>
            <WelcomePaper />
            <OurPaperProduct />
            <ImageGallery />
            <PaperAboutUs />
            {/* <GetInTouch /> */}
            <PaperGetInTouch />
            <GraceFooter />
            {/* <TestiMonials /> */}
        </>
    )
}

export default GracePaper;